import React, {useContext, useEffect, useState} from "react";
import $ from "jquery";
import moment from "moment";
import ToolsBar from "../../../toolsBar/analyze/ToolsBar";
import ExportStats from "./ExportStats";
import FilterPopup from "../../../table/FilterPopup";
import DateSelector from "../../../form/input/generated/DateSelector";
import ChartSheet from "./ChartSheet";
import LoaderCircle from "../../../loader/LoaderCircle";
import DashboardController from "../../../../stories/_statistic/Dashboard/DashboardController";
import PricelistController from "../../../../stories/_catalog/Pricelists/PricelistController";
import SubCategoryController from "../../../../stories/_catalog/SubCategories/SubCategoryController";
import stringTools from "../../../../class/tool/StringTools";
import LicenseController from "../../../../stories/_account/Licenses/LicenseController";
import SellerController from "../../../../stories/_setting/Sellers/SellerController";
import StringTools from "../../../../class/tool/StringTools";
import BackofficeContext from "../../../../context/BackofficeContext";
import StatisticContext from "../../../../context/StatisticContext";
import ListingContext from "../../../../context/ListingContext";
import "../../../../css/page/content/analyze/Statistics.css";
import "moment/locale/fr";
import TableStats from "./TableStats";
import ExportDecision from "./ExportDecision";

const Statistics = props => {
    moment.locale('fr');
    const { setErrorText } = useContext(BackofficeContext);
    const { type, dateBegin, dateEnd } = props;
    const [ loading, setLoading ] = useState({global: true, ca: false, sales: false, payments: false, vats: false, pricelists: false, categories: false, subCategories: false, products: false});
    const [ firstCall, setFirstCall ] = useState(true);
    const [ refreshStats, setRefreshStats ] = useState(true);
    const [ dashboard, setDashboard ] = useState(null);
    const [ pricelistPagination, setPricelistPagination ] = useState(null);
    const [ subCategoryPagination, setSubCategoryPagination ] = useState(null);
    const [ dateType, setDateType ] = useState(type !== null ? type : (window.matchMedia('(max-width: 640px)').matches ? "day" : "dual_day"));
    const [ dates, setDates ] = useState({});
    const [ vsDates, setVsDates ] = useState({});
    const [ strDate, setStrDate ] = useState(null);
    const [ licenses, setLicenses ] = useState([]);
    const [ sellers, setSellers ] = useState([]);
    const [ statsCA, setStatsCA ] = useState(null);
    const [ statsSales, setStatsSales ] = useState(null);
    const [ statsPayments, setStatsPayments ] = useState(null);
    const [ statsVats, setStatsVats ] = useState(null);
    const [ statsPricelists, setStatsPricelists ] = useState(null);
    const [ statsCategories, setStatsCategories ] = useState(null);
    const [ statsSubCategories, setStatsSubCategories ] = useState(null);
    const [ statsProducts, setStatsProducts ] = useState(null);
    const [ chooseExport, setChooseExport ] = useState(false);
    const [ exportForm, setExportForm ] = useState(null);
    const [ onTablet, setOnTablet ] = useState(false);
    const [ filters, setFilters ] = useState({});
    const [ filterValues, setFilterValues ] = useState({});
    const [ contextValues, setContextValues ] = useState({});
    const [ showFilters, setShowFilters ] = useState(false);
    const env = JSON.parse(localStorage.getItem("env"));
    const idRandom = Math.floor(Math.random() * 999999);

    const init = () => {
        initFilters();

        if (env.type === "store") {
            listLicenses();
            listSellers();
            listPricelists();
            listSubCategories();
        }
        else {
            setLicenses([]);
            setSellers([]);
            setPricelistPagination([]);
            setSubCategoryPagination([]);
        }
    }
    const resize = () => {
        let limitTablet = 1199;
        setOnTablet($(window).width() <= limitTablet);

        placeLoader();
    }
    const placeLoader = () => {
        const mainOffset = $(".main").offset();
        const chartSheetOffset = 170;
        const height = $(document).height() - chartSheetOffset - 40;

        $(".loaderStatistics").css({
            left: mainOffset.left + 15,
            top: chartSheetOffset + 25,
            width: ($(".main").width() - 30),
            height: height
        });
    }
    const initDates = () => {
        const begin = (dateBegin !== undefined && dateBegin !== null) ? moment(dateBegin, "DD-MM-YYYY").format() : moment().startOf((dateType === "dual_day" ? "day" : dateType)).format();
        const end = (dateEnd !== undefined && dateEnd !== null) ? moment(dateEnd, "DD-MM-YYYY").format() : moment().endOf((dateType === "dual_day" ? "day" : dateType)).format();

        changeDates({
            begin,
            end
        });
    }
    const changeDates = dates => {
        changeDateSelected(dates);
    }
    const getDashboard = () => {
        setLoadingObj(["global", "ca", "sales"], true);

        const controller = new DashboardController();
        controller._callback = returnGetDashboard;
        controller.index({
            dateType: (dateType === "dual_day" ? "day" : dateType),
            dates: dates,
            vsDates: vsDates,
            compare: true,
            withVersus: true,
            withSubPeriods: false
        }, filterValues);
    }
    const returnGetDashboard = (object, error, status) => {
        switch (status) {
            case 200:
                setDashboard(object);
                break
            default:
                setErrorText("Une erreur s'est produite lors de la requête sur cette période. Code [DASH-" + status + "]");
                break;
        }
    }
    const listLicenses = () => {
        let controller = new LicenseController();
        controller._callback = returnListLicenses;
        controller.index(env);
    }
    const returnListLicenses = (list, error, status) => {
        switch (status) {
            case 200:
                let datas = [
                    {
                        id: null,
                        name: "Toutes les caisses"
                    },
                    {
                        id: null,
                        name: "----------"
                    }
                ];

                for (let i in list) {
                    datas.push({
                        id: list[i].id,
                        name: StringTools.capitalizeFirstLetter(list[i].name.toLowerCase())
                    });
                }

                setLicenses(datas);
                break;
            default:
                console.error("Une erreur s'est produite lors de la récupération des licences. Code [G-LIC-" + status + "]");
                break;
        }
    }
    const listSellers = () => {
        let controller = new SellerController();
        controller._callback = returnListSellers;
        controller.index(null, null, null, "lastname", "asc", true);
    }
    const returnListSellers = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                let datas = [
                    {
                        id: null,
                        name: "Tous les vendeurs"
                    },
                    {
                        id: null,
                        name: "----------"
                    }
                ];

                for (let i in list) {
                    datas.push({
                        id: list[i].id,
                        name: list[i].fullname
                    });
                }

                setSellers(datas);
                break;
            default:
                console.error("Une erreur s'est produite lors de la récupération des vendeurs. Code [G-SEL-" + status + "]");
                break;
        }
    }
    const listPricelists = () => {
        let controller = new PricelistController();
        controller._callback = returnListPricelists;
        controller.index(null);
    }
    const returnListPricelists = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                setPricelistPagination(pagination !== undefined ? pagination : null);
                break;
            default:
                setErrorText("Une erreur s'est produite lors de la requête sur cette période. Code [G-PRIC-" + status + "]");
                break;
        }
    }
    const listSubCategories = () => {
        let controller = new SubCategoryController();
        controller._callback = returnListSubCategories;
        controller.index();
    }
    const returnListSubCategories = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                setSubCategoryPagination(pagination !== undefined ? pagination : null);
                break;
            default:
                setErrorText("Une erreur s'est produite lors de la requête sur cette période. Code [G-SUBC-" + status + "]");
                break;
        }
    }
    const valideDates = () => {
        setRefreshStats(true);
    }
    const launchStats = () => {
        if (loading.global && !firstCall)
            return;

        setFirstCall(false);

        if (Object.keys(dates).length === 0 && Object.keys(vsDates).length === 0)
            return;

        setRefreshStats(false);

        getDashboard();
    }
    const callStats = () => {
        if (dashboard === null || pricelistPagination === null || subCategoryPagination === null)
            return;

        const controller = new DashboardController();
        controller._callbackCA = returnGetCA;
        controller._callbackLightSalesStats = returnGetSales;
        controller._callbackPayments = returnGetPayments;
        controller._callbackVats = returnGetVats;
        controller._callbackPricelists = returnGetPricelists;
        controller._callbackCategories = returnGetCategories;
        controller._callbackSubcategories = returnGetSubCategories;
        controller._callbackProducts = returnGetProducts;

        setLoadingObj(["global", "ca", "sales"], true);

        controller.get(dashboard, "ca");
        controller.get(dashboard, "lightSalesStats");

        if (env.type === "store") {
            setLoadingObj(["payments", "vats", "categories"], true);

            controller.get(dashboard, "payments");
            controller.get(dashboard, "vats");
            controller.get(dashboard, "categories");
            controller.get(dashboard, "products");

            if (pricelistPagination !== null && pricelistPagination.total > 1) {
                setLoadingObj(["pricelists"], true);
                controller.get(dashboard, "pricelists");
            }

            if (subCategoryPagination !== null && subCategoryPagination.total > 0) {
                setLoadingObj(["subcategories"], true);
                controller.get(dashboard, "subcategories");
            }
        }
    }
    const returnGetCA = (object, error, status) => {
        setLoadingObj(["ca"], false);

        switch (status) {
            case 200:
                setStatsCA(object);
                break
            default:
                setErrorText("Une erreur s'est produite lors de la requête sur cette période. Code [CA-" + status + "]");
                break;
        }
    }
    const returnGetSales = (object, error, status) => {
        setLoadingObj(["sales"], false);

        switch (status) {
            case 200:
                setStatsSales(object);
                break;
            default:
                setErrorText("Une erreur s'est produite lors de la requête sur cette période. Code [SALE-" + status + "]");
                break;
        }
    }
    const returnGetPayments = (datas, error, status) => {
        setLoadingObj(["payments"], false);

        switch (status) {
            case 200:
                setStatsPayments(datas);
                break;
            default:
                setErrorText("Une erreur s'est produite lors de la requête sur cette période. Code [PAYM-" + status + "]");
                break;
        }
    }
    const returnGetVats = (datas, error, status) => {
        setLoadingObj(["vats"], false);

        switch (status) {
            case 200:
                setStatsVats(datas);
                break;
            default:
                setErrorText("Une erreur s'est produite lors de la requête sur cette période. Code [VAT-" + status + "]");
                break;
        }
    }
    const returnGetPricelists = (datas, error, status) => {
        setLoadingObj(["pricelists"], false);

        switch (status) {
            case 200:
                setStatsPricelists(datas);
                break;
            default:
                setErrorText("Une erreur s'est produite lors de la requête sur cette période. Code [PRIC-" + status + "]");
                break;
        }
    }
    const returnGetCategories = (datas, error, status) => {
        setLoadingObj(["categories"], false);

        switch (status) {
            case 200:
                setStatsCategories(datas);
                break;
            default:
                setErrorText("Une erreur s'est produite lors de la requête sur cette période. Code [CAT-" + status + "]");
                break;
        }
    }
    const returnGetSubCategories = (datas, error, status) => {
        setLoadingObj(["subCategories"], false);

        switch (status) {
            case 200:
                setStatsSubCategories(datas);
                break;
            default:
                setErrorText("Une erreur s'est produite lors de la requête sur cette période. Code [SUBC-" + status + "]");
                break;
        }
    }
    const returnGetProducts = (datas, error, status) => {
        setLoadingObj(["products"], false);

        switch (status) {
            case 200:
                setStatsProducts(datas);
                break;
            default:
                setErrorText("Une erreur s'est produite lors de la requête sur cette période. Code [PROD-" + status + "]");
                break;
        }
    }
    const setLoadingObj = (keys, val) => {
        let loadingKeys = Object.keys(loading);

        for (let i in loadingKeys) {
            if (keys.includes(loadingKeys[i])) {
                switch (loadingKeys[i]) {
                    case "global": setLoading(prev => ({...prev, global: val})); break;
                    case "ca": setLoading(prev => ({...prev, ca: val})); break;
                    case "sales": setLoading(prev => ({...prev, sales: val})); break;
                    case "payments": setLoading(prev => ({...prev, payments: val})); break;
                    case "vats": setLoading(prev => ({...prev, vats: val})); break;
                    case "pricelists": setLoading(prev => ({...prev, pricelists: val})); break;
                    case "categories": setLoading(prev => ({...prev, categories: val})); break;
                    case "subCategories": setLoading(prev => ({...prev, subCategories: val})); break;
                    case "products": setLoading(prev => ({...prev, products: val})); break;
                    default: break;
                }
            }
        }
    }
    const controlLoading = () => {
        let keys = Object.keys(loading);

        for (let i in keys) {
            if (keys[i] === "global") continue;

            if (loading[keys[i]])
                return;
        }

        if (loading.global && !firstCall)
            setLoadingObj(["global"], false);
    }
    const exportStats = () => {
        setChooseExport(!exportForm);
    }
    const closeChoose = () => {
        setChooseExport(false);
    }
    const validChoose = type => {
        closeChoose();

        setExportForm(type);
    }
    const closeExportStats = () => {
        setExportForm(null);
    }
    const buildStrDate = () => {
        if (dates === undefined || dates === null)
            return;

        try {
            let dateBegin = moment(dates.begin);
            let dateEnd = dates.end !== undefined && dates.end !== null ? moment(dates.end) : dateBegin;

            switch (dateType) {
                case "day":
                    setStrDate("Le " + dateBegin.format("ddd DD MMMM YYYY"));
                    break;
                case "dual_day":
                    if (Math.abs(dateBegin.diff(dateEnd, 'days')) > 1)
                        setStrDate("du " + dateBegin.format("ddd DD MMMM YYYY") + " au " + moment(dateEnd).format("ddd DD MMMM YYYY"));
                    else
                        setStrDate(dateBegin.format("ddd DD MMMM YYYY"));

                    break;
                case "month":
                    if (Math.abs(dateBegin.diff(dateEnd, 'months')) > 1)
                        setStrDate("de " + dateBegin.format("MMMM YYYY") + " à " + moment(dateEnd).format("MMMM YYYY"));
                    else
                        setStrDate(dateBegin.format("MMMM YYYY"));

                    break;
                case "year":
                    if (Math.abs(dateBegin.diff(dateEnd, 'years')) > 1)
                        setStrDate("de " + dateBegin.format("YYYY") + " à " + moment(dateEnd).format("YYYY"));
                    else
                        setStrDate("Année " + dateBegin.format("YYYY"));

                    break;
                default:
                    setStrDate(null);
                    break;
            }
        }
        catch (e) { console.error(e); }
    }
    const buildVs = () => {
        let createdDate = moment();

        try {
            switch (env.type) {
                case "company":
                    for (let i in env.stores) {
                        if (moment(env.stores[i].created_at).isBefore(createdDate)) {
                            createdDate = moment(env.stores[i].created_at);
                        }
                    }

                    break;
                case "store":
                    createdDate = moment(env.created_at);
                    break;
                default:
                    break;
            }

            let start = moment(dates.begin);
            let end = dates.end !== null ? moment(dates.end) : null;

            switch (dateType) {
                case "dual_day":
                case "day":
                    if (Math.abs(moment(start).diff(moment(end), 'days')) > 1) {
                        start.subtract(1, "years");

                        if (end !== null) end.subtract(1, "years");
                    } else {
                        if (moment(start).subtract(1, "years").isAfter(createdDate)) {
                            start.subtract(1, "years");

                            if (end !== null) end.subtract(1, "years");
                        } else if (moment(start).subtract(1, "weeks").isAfter(createdDate)) {
                            start.subtract(1, "weeks");

                            if (end !== null) end.subtract(1, "weeks");
                        } else {
                            start.subtract(1, "days");

                            if (end !== null) end.subtract(1, "days");
                        }
                    }

                    break;
                case "month":
                    if (Math.abs(moment(start).diff(moment(end), 'months')) > 1) {
                        start.subtract(1, "years");

                        if (end !== null) end.subtract(1, "years").endOf("month");
                    } else {
                        if (moment(start).subtract(1, "years").isAfter(createdDate)) {
                            start.subtract(1, "years");

                            if (end !== null) end.subtract(1, "years").endOf("month");
                        } else {
                            start.subtract(1, "months");

                            if (end !== null) end.subtract(1, "months").endOf("month");
                        }
                    }

                    break;
                case "quarter":
                    if (Math.abs(moment(start).diff(moment(end), 'months')) > 3) {
                        start.subtract(1, "years");

                        if (end !== null) end.subtract(1, "years").endOf("month");
                    } else {
                        if (moment(start).subtract(1, "years").isAfter(createdDate)) {
                            start.subtract(1, "years");

                            if (end !== null) end.subtract(1, "years").endOf("month");
                        } else {
                            start.subtract(1, "quarters");

                            if (end !== null) end.subtract(1, "quarters").endOf("month");
                        }
                    }

                    break;
                case "year":
                    start.subtract(1, "years");

                    if (end !== null) end.subtract(1, "years");

                    break;
                default:
                    break;
            }

            changeVsDateSelected({
                begin: start.format(),
                end: end.format(),
            });
        }
        catch (e) { console.error(e); }
    }
    const openFilters = () => {
        setShowFilters(true);
    }
    const closeFilters = () => {
        setShowFilters(false);
    }
    const validFilters = values => {
        closeFilters();
        setFilterValues(values);
    }
    const initFilters = () => {
        setFilterValues(prev => ({
            ...prev,
            license_id: null,
            seller_id: null,
            licenses: [],
            sellers: []
        }));
    }
    const updateFilters = () => {
        setFilters(prev => ({
            ...prev,
            licenses: licenses,
            sellers: sellers
        }));
    }
    const changeDateSelected = dates => {
        setDates({
            begin: dates.begin,
            end: dates.end
        });
    }
    const changeVsDateSelected = dates => {
        setVsDates({
            begin: dates.begin,
            end: dates.end
        });
    }

    useEffect(() => {
        document.title = "Back office - Analyse";
        window.addEventListener('resize', resize);
        resize();
        init();

        return () => window.removeEventListener('resize', resize);
    }, []);
    useEffect(() => {
        controlLoading();
    }, [loading]);
    useEffect(() => {
        initDates();
    }, [dateType]);
    useEffect(() => {
        callStats();
    }, [dashboard, pricelistPagination, subCategoryPagination]);
    useEffect(() => {
        buildStrDate();
        buildVs();
    }, [dates]);
    useEffect(() => {
        setRefreshStats(true);
        buildStrDate();
        buildVs();
    }, [dateType]);
    useEffect(() => {
        setRefreshStats(true);
    }, [filterValues]);
    useEffect(() => {
        if (Object.keys(dates).length > 0 && Object.keys(vsDates).length > 0 && refreshStats)
            launchStats();
    }, [dates, vsDates, refreshStats]);
    useEffect(() => {
        updateFilters();
    }, [licenses, sellers]);
    useEffect(() => {
        setContextValues(prev => ({
            ...prev,
            typeFilters: "statistics",
            filters,
            filterValues,
            showFilters,
            openFilters,
            closeFilters,
            validFilters
        }));
    }, [showFilters, filters, filterValues]);

    return(
        <StatisticContext.Provider value={{dateType, setDateType, dates, setDates: changeDateSelected, pricelists: pricelistPagination, subCategories: subCategoryPagination, loading, statsCA, statsSales, statsPayments, statsVats, statsPricelists, statsCategories, statsSubCategories, statsProducts}}>
            <ListingContext.Provider value={contextValues}>
                <FilterPopup />
                {
                    chooseExport
                    && <ExportDecision cancel={closeChoose} valid={validChoose} />
                }
                {
                    exportForm !== null
                    && <ExportStats
                        type={exportForm === 1 ? "analyse" : "soldQuantities"}
                        cancel={closeExportStats}
                        dates={{
                            dates: dates,
                            vsDates: vsDates,
                            compare: true,
                            withVersus: true,
                            withSubPeriods: true
                        }}
                        filters={filterValues}
                    />
                }
                <div className="main paddingBottom">
                    <ToolsBar launchStats={valideDates} launchExport={exportStats} dateTypesAvailable={['D', 'M', 'Y']} />
                    {
                        strDate !== null
                        && <div className={"dateStatistics"}>
                            <p className={"date"}>{strDate !== null ? stringTools.capitalizeFirstLetter(strDate) : ""}</p>
                            <DateSelector random={idRandom} attribute={"dateCompare"} returnType={"string"} classname={"vs"} type={dateType} value={vsDates} baseValue={dates} change={changeVsDateSelected} noCompare={true} validCalendar={valideDates} />
                        </div>
                    }
                    {
                        env.type === "company" && <TableStats ca={statsCA} sales={statsSales} />
                    }
                    {
                        env.type === "store" && <ChartSheet />
                    }
                </div>
                <div className={"loaderStatistics " + (loading.global ? "visible" : "hidden")}>
                    <div className={"content"}>
                    <LoaderCircle display="loader" strokeWidth="10" stroke={"#00406F"} />
                    <p>Calcul en cours ...</p>
                    </div>
                </div>
            </ListingContext.Provider>
        </StatisticContext.Provider>
    );
}

export default Statistics;